import { createMuiTheme } from "@material-ui/core";

/* eslint-disable @typescript-eslint/no-unused-vars */
const tngPrimaryPetrol = "rgb(0, 71, 84)";
const tngPrimaryPetrol80 = "rgb(51, 108, 118)";
const tngPrimaryPetrol60 = "rgb(102, 145, 152)";
const tngPrimaryPetrol40 = "rgb(153, 181, 187)";
const tngPrimaryPetrol20 = "rgb(204, 218, 221 )";

const tngPrimaryLime = "rgb(190, 189, 0)";
const tngPrimaryLime80 = "rgb(203, 202, 51)";
const tngPrimaryLime60 = "rgb(216, 215, 102)";
const tngPrimaryLime40 = "rgb(229, 229, 153)";
const tngPrimaryLime20 = "rgb(242, 242, 204)";

const tngSecondaryLightblue = "rgb(107, 145, 151)";

const tngSecondaryLightyellow = "rgb(230, 229, 152)";

const tngSecondaryGrey = "rgb(61, 60, 60)";
const tngSecondaryGrey60 = "rgb(139, 138, 138)";
const tngSecondaryGrey40 = "rgb(177, 177, 177)";

const tngSignaldarkred = "rgb(140, 39, 45)";
const tngSignalSignalred = "rgb(185, 0, 0)";
const tngSignalorange = "rgb(237, 110, 0)";
const tngSignalmustardyellow = "rgb(219, 158, 54)";
const tngSignalSignalblue = "rgb(23, 121, 146)";
/* eslint-enable @typescript-eslint/no-unused-vars */

export const transnetTheme = createMuiTheme({
    palette: {
        primary: {
            main: tngPrimaryPetrol,
            light: tngPrimaryPetrol80
        },
        secondary: {
            main: tngPrimaryLime,
        },
        error: {
            main: tngSignalSignalred,
        },
        info:{
            main: tngPrimaryPetrol,
            light: tngPrimaryPetrol60,
        }
    },
    typography: {
        fontFamily: [
            'Avenir Next LT Pro',
            'Arial',
        ].join(','),
    },

})
transnetTheme.props = {
    MuiFormLabel: {
        focused: false,
    },
    MuiFormControl: {
        fullWidth: false,
    }
}
